export default __webpack_public_path__ + "static/media/transport.2655c5e8.jpg";